// extracted by mini-css-extract-plugin
export var button = "_pa-0";